import { templates as pages } from "./components/pages";
import { templates as addons } from "./components/addons";

const templates = [
    ...addons,
    ...pages,
];

export default templates;